export const KEYSFOBS_DELETE_REQUEST = "KEYSFOBS_DELETE_REQUEST";
export const KEYSFOBS_DELETE_RESULT = "KEYSFOBS_DELETE_RESULT";
export const KEYSFOBS_DELETE_OPEN_MODAL = "KEYSFOBS_DELETE_OPEN_MODAL";